import { render, staticRenderFns } from "./OrderListExchangeNew.vue?vue&type=template&id=d77958c4&scoped=true"
import script from "./OrderListExchangeNew.vue?vue&type=script&lang=js"
export * from "./OrderListExchangeNew.vue?vue&type=script&lang=js"
import style0 from "./OrderListExchangeNew.vue?vue&type=style&index=0&id=d77958c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77958c4",
  null
  
)

export default component.exports